
/* Traffic source for quiz leads (np:src 12 Oct 2026): remembers the last non-direct source for 30 days. */
(function(){
  try{
    var q=new URLSearchParams(location.search), s='', c=q.get('utm_campaign')||'';
    if(q.get('utm_source')) s=q.get('utm_source');
    else if(q.get('gclid')||q.get('gbraid')||q.get('wbraid')) s='google-ads';
    else if(q.get('fbclid')) s='meta';
    else if(document.referrer){ var h=new URL(document.referrer).hostname.replace(/^www\./,''); if(h && h.indexOf('ninepadel')<0 && h.indexOf('shopify')<0){ s=/google\./.test(h)?'google':/(^|\.)(facebook|fb)\.com$/.test(h)||h=='l.facebook.com'||h=='m.facebook.com'?'facebook':/instagram\.com$/.test(h)?'instagram':/tiktok\.com$/.test(h)?'tiktok':/bing\.com$/.test(h)?'bing':h; } }
    var clean=function(v){ return String(v).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,40); };
    if(s){ localStorage.setItem('np_src', JSON.stringify({s:clean(s), c:c?clean(c):'', t:Date.now()})); }
    window.NP = window.NP || {};
    NP.source = function(){ try{ var o=JSON.parse(localStorage.getItem('np_src')||'null'); if(o && Date.now()-o.t < 2592e6) return o; }catch(e){} return {s:'direct',c:''}; };
  }catch(e){ window.NP = window.NP || {}; NP.source = function(){ return {s:'direct',c:''}; }; }
})();
/* NINEPADEL core JS: money, cart API helpers, AJAX add-to-cart, countdown, small UI helpers.
   Events: document 'np:cart:changed' (detail = cart JSON), 'np:cart:open'. */
(function(){
  var NP = window.NP = window.NP || {};
  NP.formatMoney = function(cents){
    var v = (cents/100);
    var s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
    return (NP.sym || '£') + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  NP.getCart = function(){ return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}); };
  NP.emitCart = function(cart){ document.dispatchEvent(new CustomEvent('np:cart:changed',{detail:cart})); };
  NP.refreshCart = function(){ return NP.getCart().then(function(c){ NP.emitCart(c); return c; }); };
  /* NP.addHooks: functions(items) run before every add. Return false to cancel (the hook shows its own message). */
  NP.addHooks = NP.addHooks || [];
  NP.addItems = function(items){
    for(var h = 0; h < NP.addHooks.length; h++){ if(NP.addHooks[h](items) === false) return Promise.reject({silent:true}); }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(){ return NP.refreshCart(); });
  };
  NP.changeLine = function(key, qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:qty})})
            .then(function(r){ return r.json().then(function(j){ if(!r.ok || j.status) throw j; return j; }); }).then(function(c){ NP.emitCart(c); return c; });
  };
  NP.openCart = function(){ document.dispatchEvent(new CustomEvent('np:cart:open')); };
  /* Any <form data-np-add> (product forms) adds via AJAX and opens the drawer. */
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[data-np-add]'); if(!f) return;
    e.preventDefault();
    var fd = new FormData(f), items = [];
    var props = {}; fd.forEach(function(v, k){ var m = /^properties\[(.+)\]$/.exec(k); if(m && String(v).trim() !== '') props[m[1]] = String(v).trim(); });
    var id = fd.get('id'); if(id) items.push({id: +id, quantity: +(fd.get('quantity')||1), properties: props});
    f.querySelectorAll('[data-np-extra]:checked, [data-np-extra][aria-pressed="true"]').forEach(function(x){ items.push({id:+x.value || +x.dataset.variant, quantity:1}); });
    var btn = f.querySelector('[type=submit]'); if(btn){ btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.innerHTML; btn.innerHTML = 'Adding…'; }
    NP.addItems(items).then(function(){ NP.openCart(); })
      .catch(function(err){ if(!(err && err.silent)) alert((err && (err.description || err.message)) || 'Sorry, that could not be added.'); })
      .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = btn.dataset.label; } });
  });
  /* Countdown: <span data-np-cutoff></span> -> "Order in 3h 12m for delivery tomorrow" style text */
  NP.cutoff = function(){
    var d = new Date(), c = new Date(d); c.setHours(NP.cutoffHour||14,0,0,0);
    var wk = d.getDay()>0 && d.getDay()<6;
    function next(x){ x = new Date(x); do { x.setDate(x.getDate()+1); } while(x.getDay()===0 || x.getDay()===6); return x; }
    var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], mo=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var ship = (wk && d < c) ? d : next(d); var arrive = next(ship);
    var ms = (wk && d < c) ? c - d : null;
    return { ship: ship, arrive: arrive, open: ms !== null, h: ms ? Math.floor(ms/36e5) : 0, m: ms ? Math.floor(ms%36e5/6e4) : 0, day: days[arrive.getDay()]+' '+arrive.getDate()+' '+mo[arrive.getMonth()] };
  };
  function paintCutoffs(){
    var c = NP.cutoff();
    document.querySelectorAll('[data-np-cutoff]').forEach(function(el){
      el.innerHTML = c.open ? 'Order in <b>'+c.h+'h '+c.m+'m</b> for delivery <b>'+c.day+'</b> (UK)' : 'Order now for delivery <b>'+c.day+'</b> (UK)';
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ paintCutoffs(); setInterval(paintCutoffs, 60000); });
})();

/* Tracking: Shopify fires "added to cart" once for the /cart/add.js call and again for any submitted
   form whose action is /cart/add, so AJAX product forms were double counted in Meta/GA4/Google Ads.
   Strip the action from JS-handled forms (np:fix 12 Oct 2026). */
(function(){
  function strip(root){ (root||document).querySelectorAll('form[data-np-add][action]').forEach(function(f){ f.removeAttribute('action'); }); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ strip(); }); else strip();
  document.addEventListener('submit', function(e){ var f = e.target && e.target.closest && e.target.closest('form[data-np-add][action]'); if(f) f.removeAttribute('action'); }, true);
})();
